export const CoreMonthlyPlanID = 'core-monthly';
export const CoreYearlyPlanID = 'core-yearly';
export const CorePlanIDs = [CoreMonthlyPlanID, CoreYearlyPlanID];

export default (planID?: string | null) => {
  if (!planID) {
    return false;
  }

  return CorePlanIDs.includes(planID);
};
